export const flightDuration = (OD) => {
  return OD.tdu.substring(0, 2) + "h " + OD.tdu.substring(3, 5) + "m";
}

export const arrivalDuration = (flightSchedule) => {
    const FS = flightSchedule[0].FS;
    return FS[FS.length - 1].ad;
}


// WEBPACK FOOTER //
// ./src/utility.js